function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M26.34,4.58l0-1.13V3H22.8A159.12,159.12,0,0,0,10.08,20,23.42,23.42,0,0,1,15,25.86c-.55.37-1.13.7-1.71,1A21.91,21.91,0,0,0,8.13,21,22.63,22.63,0,0,0,3,17.85V29.79c6.19-.53,11.27-2.66,15.12-6.39C23.84,17.88,26.47,8.36,26.34,4.58Z",
  fill: "#e8e8e8"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M32,11.81c.77.23,1.43.46,1.94.64a9.9,9.9,0,0,0,1,.33A1.27,1.27,0,0,0,36.54,12c.37-1.21,1.65-5.73,2.37-8.45A3.86,3.86,0,0,0,37,3H32.84A5.65,5.65,0,0,1,33,4.36,27.1,27.1,0,0,1,32,11.81Z",
  fill: "#e8e8e8"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M9.5,35.07c-.43.12-.86.22-1.29.31C8.64,35.29,9.07,35.19,9.5,35.07Z",
  fill: "#e8e8e8"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M20.2,3H7A4,4,0,0,0,3,7v8.69a24.29,24.29,0,0,1,5.5,3.06A160.14,160.14,0,0,1,20.2,3Z",
  fill: "#e8e8e8"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M16.58,37.06v-.22a1.22,1.22,0,0,0-.43-.79,1.14,1.14,0,0,0-.86-.26H9.9a3.31,3.31,0,0,1-1.7-.42,34.58,34.58,0,0,1-5.2.7V37a4,4,0,0,0,4,4h9.57C16.56,39.52,16.56,37.79,16.58,37.06Z",
  fill: "#e8e8e8"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M38.46,12.55a3.27,3.27,0,0,1-3.12,2.3,3.2,3.2,0,0,1-.92-.13,11.88,11.88,0,0,1-1.19-.38c-.5-.18-1.13-.4-1.87-.62a36.83,36.83,0,0,1-8.23,13.49,27.75,27.75,0,0,1-9.74,6.59h1.75a3.13,3.13,0,0,1,2.27.71,3.19,3.19,0,0,1,1.16,2.14,4.34,4.34,0,0,1,0,.51c0,.68,0,2.39,0,3.85H37a4,4,0,0,0,4-4V7a4,4,0,0,0-.46-1.83C39.8,7.89,38.79,11.45,38.46,12.55Z",
  fill: "#e8e8e8"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M12.22,34.24l-.31.11Z",
  fill: "#e8e8e8"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M10.87,34.69l-.5.14Z",
  fill: "#e8e8e8"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M13.3,26.88c.58-.32,1.16-.65,1.71-1A23.42,23.42,0,0,0,10.08,20,159.12,159.12,0,0,1,22.8,3H20.2A160.14,160.14,0,0,0,8.5,18.75,24.29,24.29,0,0,0,3,15.69v2.16A22.63,22.63,0,0,1,8.13,21,21.91,21.91,0,0,1,13.3,26.88Z",
  fill: "#f7f7f7"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M18.58,37.15a4.34,4.34,0,0,0,0-.51,3.19,3.19,0,0,0-1.16-2.14,3.13,3.13,0,0,0-2.27-.71H13.39l-1.17.44-.31.11-1,.34-.5.14q-.43.14-.87.24c-.43.12-.86.22-1.29.31h0a3.31,3.31,0,0,0,1.7.42h5.39a1.14,1.14,0,0,1,.86.26,1.22,1.22,0,0,1,.43.79v.22c0,.73,0,2.46,0,3.94h2C18.56,39.54,18.56,37.83,18.58,37.15Z",
  fill: "#f7f7f7"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M34.92,12.78a9.9,9.9,0,0,1-1-.33c-.51-.18-1.17-.41-1.94-.64-.17.62-.37,1.26-.59,1.91.74.22,1.37.44,1.87.62a11.88,11.88,0,0,0,1.19.38,3.2,3.2,0,0,0,.92.13,3.27,3.27,0,0,0,3.12-2.3c.33-1.1,1.34-4.66,2.08-7.38a4,4,0,0,0-1.63-1.66c-.72,2.72-2,7.24-2.37,8.45A1.27,1.27,0,0,1,34.92,12.78Z",
  fill: "#f7f7f7"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M32,4.37A4.86,4.86,0,0,0,31.8,3H27.3v.42l0,1.13c.16,4.48-2.79,14-8.53,19.57C14.84,28,9.41,30.24,3,30.79v4.28c4.85-.31,12.89-1.74,19.41-8.55C30.14,18.44,32.09,8.8,32,4.37Z",
  fill: "#fff2af"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M27.34,4.55l0-1.13V3h-1v.45l0,1.13c.13,3.78-2.5,13.3-8.22,18.82C14.27,27.13,9.19,29.26,3,29.79v1c6.41-.55,11.84-2.82,15.81-6.67C24.55,18.58,27.5,9,27.34,4.55Z",
  fill: "#f6cf65"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M8.21,35.38c.43-.09.86-.19,1.29-.31s.58-.15.87-.24l.5-.14,1-.34.31-.11,1.17-.44a27.75,27.75,0,0,0,9.74-6.59,36.83,36.83,0,0,0,8.23-13.49c.22-.65.42-1.29.59-1.91A27.1,27.1,0,0,0,33,4.36,5.65,5.65,0,0,0,32.84,3h-1A4.86,4.86,0,0,1,32,4.37c.06,4.43-1.89,14.07-9.62,22.15C15.89,33.33,7.85,34.76,3,35.07v1a34.58,34.58,0,0,0,5.2-.7Z",
  fill: "#f6cf65"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M34.1,45.39a.74.74,0,0,1-.53-.22l-8-8.05a12.07,12.07,0,0,1-2.2-3.29,12.45,12.45,0,0,1-1-4.84A11.57,11.57,0,0,1,33.56,17.13H34A11.9,11.9,0,0,1,45.85,29a12.83,12.83,0,0,1-1,4.82A11.89,11.89,0,0,1,42.7,37.1l-8.07,8.07A.74.74,0,0,1,34.1,45.39Zm-.19-26.76h-.3A10.07,10.07,0,0,0,23.85,29a10.92,10.92,0,0,0,.85,4.27,10.49,10.49,0,0,0,1.9,2.83l7.5,7.51,7.52-7.52a10.28,10.28,0,0,0,1.89-2.84A11.31,11.31,0,0,0,44.35,29,10.4,10.4,0,0,0,34,18.63Z",
  fill: "#fff"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M34,18.63h-.38A10.07,10.07,0,0,0,23.85,29a10.92,10.92,0,0,0,.85,4.27,10.49,10.49,0,0,0,1.9,2.83l7.5,7.51,7.52-7.52a10.28,10.28,0,0,0,1.89-2.84A11.31,11.31,0,0,0,44.35,29,10.4,10.4,0,0,0,34,18.63Zm.08,17.25a2.32,2.32,0,1,1,2.31-2.31A2.32,2.32,0,0,1,34.07,35.88Zm4.13-5.75a.75.75,0,0,1-.59.29.74.74,0,0,1-.46-.16,5,5,0,0,0-6.17,0,.74.74,0,0,1-1.05-.13.76.76,0,0,1,.13-1.05,6.5,6.5,0,0,1,8,0A.74.74,0,0,1,38.2,30.13Zm2.54-2.51a.75.75,0,0,1-1.05.12,8.94,8.94,0,0,0-5.55-1.94H34a9,9,0,0,0-5.57,1.94.75.75,0,0,1-.93-1.18A10.47,10.47,0,0,1,34,24.3h.15a10.41,10.41,0,0,1,6.47,2.26A.75.75,0,0,1,40.74,27.62Z",
  fill: "#33ba69"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M30.06,29.08a.76.76,0,0,0-.13,1.05.74.74,0,0,0,1.05.13,5,5,0,0,1,6.17,0,.74.74,0,0,0,.46.16.75.75,0,0,0,.59-.29.74.74,0,0,0-.13-1.05A6.5,6.5,0,0,0,30.06,29.08Z",
  fill: "#fff"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M40.62,26.56a10.41,10.41,0,0,0-6.47-2.26H34a10.47,10.47,0,0,0-6.49,2.26.75.75,0,0,0,.93,1.18A9,9,0,0,1,34,25.8h.13a8.94,8.94,0,0,1,5.55,1.94.75.75,0,0,0,.93-1.18Z",
  fill: "#fff"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M34.07,31.25a2.32,2.32,0,1,0,2.31,2.32A2.32,2.32,0,0,0,34.07,31.25Z",
  fill: "#fff"
});

var SvgAppIcon = function SvgAppIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAppIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/app_icon.3090897d.svg";
export { ForwardRef as ReactComponent };